import React from "react";

const AcademyReplyOptions = ({ reply, disabled, onSelect }) => {
  if (!reply?.options?.length) return null;
  return (
    <div role="group" aria-label="Academy reply options" className="d-flex flex-wrap gap-2 mt-2 mb-2">
      {reply.options.map((option) => (
        <button
          type="button"
          className="btn btn-outline-primary btn-sm"
          key={option.id}
          disabled={disabled}
          onClick={() => onSelect(option)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default AcademyReplyOptions;
